import { gql } from '@apollo/client'
import { DRAW_MAP_TASK_FRAGMENT } from '../fragments/DrawMapTaskFragment'

export const GET_DRAW_MAP_TASKS = gql`
  query GetDrawMapTasks($input: IndoorMapDrawTaskInput!) {
    drawMapTasks(input: $input) {
      hasMore
      count
      results {
        ...DrawMapTask
      }
    }
  }
  ${DRAW_MAP_TASK_FRAGMENT}
`
